var React = require('react');

function IconRisk (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M887.7 196.1l-31.4-.5c-.8 0-80.5-1.6-172.2-38-92-36.6-151.9-78.7-153.7-80h.1l-19.1-13.5-19 13.5h.1c-2 1.5-61.1 43.2-153.7 80-91.6 36.3-179.5 38-180.3 38l-30.7.5v379.4c-1 85 50.8 180.9 141.3 263.1 39.4 35.8 83.2 66.2 126.7 87.9 43.4 21.6 83.4 33.1 115.7 33.1 66.1 0 159.6-47.4 238.2-120.9 87.8-82 138.1-177.9 138.1-263.2l-.1-379.4zm-54.6 377c0 153.4-225.3 329.1-320.7 329.1-47.8 0-126.6-43.8-198.9-106.5C228.7 722.1 191 641 191 573.1V254.2l6.6-.7c73-7.7 125-21.5 171.4-39.9 69.7-27.8 115.4-57.3 139.4-72.4l4-2.5 4 2.5c24.4 15.3 80.6 45 149.5 72.4 61.2 24.3 115.2 35.1 160.7 39.9l6.6.7-.1 318.9z","key":0}),React.createElement("path",{"d":"M591.3 328.7l-138.4-.7-70.2 244.2 95.4-4.7-39 168.9L639.9 459l-113 14.4 64.4-144.7z","key":1})]);
}

IconRisk.displayName = "IconRisk";

IconRisk.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconRisk;

IconRisk.default = IconRisk;
